<template>
	<div class="card mt-4">
        <div class="card-header">
            <div class="row">
	            <div class="d-flex justify-content-between container-fluid">
			        <div class="text-muted fs-19">
			            <strong>Pedidos Abertos</strong>
			        </div>
				</div>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
            	<div class="col-xl-3 col-md-6 mb-4">
            		<bga2-info-card classe="border-left-warning">
            			<div class="col mr-2">
		        			<div class="text-xs font-weight-bold text-warning text-uppercase mb-1">
		            			Não Iniciado
		        			</div>
		        			<div class="h5 mb-0 font-weight-bold text-gray-800">	
		        				{{ dados.pedidos_nao_iniciados }}
		        			</div>
		    			</div>
						<div class="col-auto">
		        			<i class="fas fa-hourglass fa-2x text-gray-300"></i>
		    			</div>
            		</bga2-info-card>
            	</div>
            	<div class="col-xl-3 col-md-6 mb-4">
            		<bga2-info-card classe="border-left-primary">
            			<div class="col mr-2">
		        			<div class="text-xs font-weight-bold text-primary text-uppercase mb-1">
		            			Em Produção
		        			</div>
		        			<div class="h5 mb-0 font-weight-bold text-gray-800">	
		        				{{ dados.pedidos_producao }}
		        			</div>
		    			</div>
						<div class="col-auto">
		        			<i class="fas fa-wrench fa-2x text-gray-300"></i>
		    			</div>
            		</bga2-info-card>
            	</div>
            	<div class="col-xl-3 col-md-6 mb-4">
            		<bga2-info-card classe="border-left-warning">
            			<div class="col mr-2">
		        			<div class="text-xs font-weight-bold text-warning text-uppercase mb-1">
		            			Prazos Apertados
		        			</div>
		        			<div class="h5 mb-0 font-weight-bold text-gray-800">	
		        				{{ dados.pedidos_prazo_apertado }}
		        			</div>
		    			</div>
						<div class="col-auto">
		        			<i class="fas fa-calendar fa-2x text-gray-300"></i>
		    			</div>
            		</bga2-info-card>
            	</div>
            	<div class="col-xl-3 col-md-6 mb-4">
            		<bga2-info-card classe="border-left-danger">
            			<div class="col mr-2">
		        			<div class="text-xs font-weight-bold text-danger text-uppercase mb-1">
		            			Prazos Vencidos
		        			</div>
		        			<div class="h5 mb-0 font-weight-bold text-gray-800">	
		        				{{ dados.pedidos_prazo_vencido }}
		        			</div>
		    			</div>
						<div class="col-auto">
		        			<i class="fas fa-calendar fa-2x text-gray-300"></i>
		    			</div>
            		</bga2-info-card>
            	</div>
		    </div>
        </div>
    </div>
</template>

<script>
	export default {
		props: ['dados']
	}
</script>